import { getGlobalUserId } from "shared/src/framework/network/headers";
import { userSetPlayerId } from "shared/src/network/requests/user/user-req";
import { Analytic } from "src/analytic/analytic";
import { oneSignal } from "./lib";
import { OneSignalUserTags } from "./models";
import { OneSignal } from "./one-signal";

export class OneSignalHelpers {
    static initWebApp = ({
        promptMsg,
        welcomeNotificationMsg,
    }: {
        promptMsg: string;
        welcomeNotificationMsg: string;
    }) => {
        oneSignal().push(() => {
            Analytic.addEvent({ event: "push_notification_init_call", defaultGTMConfig: "true" });
            oneSignal()
                .init({
                    appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
                    safari_web_id: process.env.REACT_APP_ONESIGNAL_SAFARI_APP_ID,
                    allowLocalhostAsSecureOrigin: true,
                    promptOptions: {
                        actionMessage: promptMsg,
                        showCredit: false,
                        acceptButtonText: "Yes, notify me",
                        cancelButtonText: "Not yet",
                    },
                    welcomeNotification: {
                        title: "Flashmob",
                        message: welcomeNotificationMsg,
                    },
                })
                .catch((e: Error) => {
                    Analytic.addEvent({
                        event: "push_notification_popover_error",
                        defaultGTMConfig: "true",
                    });
                });
        });
    };

    //READ more about these events here https://documentation.onesignal.com/docs/web-push-sdk#section-subscription-change
    static setupEventListeners = () => {
        oneSignal().push(() => {
            oneSignal().on("subscriptionChange", OneSignalHelpers.onSubscriptionChange);
            oneSignal().on("notificationPermissionChange", OneSignalHelpers.onPermissionChange);
            oneSignal().on("popoverShown", OneSignalHelpers.onPopoverShown);
            oneSignal().on("popoverAllowClick", OneSignalHelpers.onPopoverAllowClick);
            oneSignal().on("popoverCancelClick", OneSignalHelpers.onPopoverCancelClick);
            oneSignal().on("popoverClosed", OneSignalHelpers.onPopoverClosed);
        });
    };

    static onPopoverShown = () => {
        Analytic.addEvent({ event: "push_notification_popover_shown", defaultGTMConfig: "true" });
    };

    static onPopoverAllowClick = () => {
        Analytic.addEvent({
            event: "push_notification_popover_allow_click",
            defaultGTMConfig: "true",
        });
    };

    static onPopoverCancelClick = () => {
        Analytic.addEvent({
            event: "push_notification_popover_cancel_click",
            defaultGTMConfig: "true",
        });
    };

    static onPopoverClosed = () => {
        Analytic.addEvent({ event: "push_notification_popover_closed", defaultGTMConfig: "true" });
    };

    static async onSubscriptionChange(isSubscribed: boolean) {
        //TODO: Figure out what to do on subscription change
        const userId = getGlobalUserId();
        if (isSubscribed && !!userId) {
            const defaultTags: OneSignalUserTags = {
                userId,
                signedOut: false,
            };
            OneSignal.saveTags(defaultTags);
            OneSignalHelpers.setExtUserId(userId);
            const playerId = await OneSignalHelpers.getPlayerId();
            if (!!playerId) {
                userSetPlayerId({
                    playerId,
                });
            }
        } else {
        }
    }

    static onPermissionChange(permissionInfo: { to: "granted" | "denied" | "default" }) {
        const event =
            permissionInfo.to === "granted"
                ? "push_notification_permission_granted"
                : permissionInfo.to === "denied"
                ? "push_notification_permission_denied"
                : permissionInfo.to === "default"
                ? "push_notification_permission_default"
                : undefined;
        if (event) {
            Analytic.addEvent({ event, defaultGTMConfig: "true" });
        }
    }

    static getPlayerId = async () => {
        if (oneSignal().getUserId) {
            return Promise.resolve(oneSignal().getUserId());
        }

        return Promise.resolve();
    };

    static setExtUserId = (pId?: string) => {
        oneSignal().push(() => {
            if (pId) {
                oneSignal().setExternalUserId(pId);
            } else {
                oneSignal().removeExternalUserId();
            }
        });
    };

    static isPushNotificationsSupported = () => {
        return oneSignal().isPushNotificationsSupported();
    };
}
